import React, { ReactElement } from 'react';
import { ReactComponent as CrossCircleBlue } from '../../../assets/images/svg/cross_circle_blue.svg';
import './customTag.less';

export const CustomTag = (props: any): (ReactElement | null) => {

  const {text, onRemove, removable = false} = props;
  return (<>
      {
        text &&
        <div className="flex flex-element flex-row custom-tag">
          <div className={ `flex flex-element items-center justify-center`}>
              {text}
          </div>
          {
            removable &&
            <CrossCircleBlue className="cross-icon mouse-pointer" onClick={onRemove}/>
          }
        </div>
      }
    </>);
};
export default CustomTag;
